namespace $.$$ {

	export class $shm_hitalama_vk_lists extends $.$shm_hitalama_vk_lists {
		
		@ $mol_mem
		current_view() {
			return this.$.$mol_state_arg.value( 'create' ) 
				? this.Creating()
				: this.$.$mol_state_arg.value( 'edit' ) 
					? this.Editing()
					: this.Main()
		}

		@ $mol_mem
		token_str() {
			return this.token()?.Token()?.val() || ''
		}

		@ $mol_mem_key
		group_list( ref: $giper_baza_link ) {
			return this.$.$giper_baza_glob.Pawn( ref, $shm_hitalama_vk_list )
		}

		@ $mol_mem_key
		name( ref: $giper_baza_link ) {
			return this.group_list( ref ).Name()?.val() || ''
		}

		@ $mol_mem
		lists() {
			return this.$.$shm_hitalama_profile.current()?.Groups_lists()?.remote_list().map( l => this.List( l.link() ) ) ?? []
		}

		@ $mol_mem_key
		groups( ref: $giper_baza_link ) {
			return this.group_list( ref ).Groups()?.remote_list().map( g => this.Group( g.link() ) ) ?? []
		}

		@ $mol_mem_key
		group_photo_uri( ref: $giper_baza_link ) {
			return this.$.$giper_baza_glob.Pawn( ref, $shm_hitalama_vk_group ).Photo_url()?.val() ?? ''
		}

		@ $mol_mem_key
		ref_str( ref: $giper_baza_link ) {
			return ref.toString()
		}

		@ $mol_mem
		list_editing() {
			const ref_str = this.$.$mol_state_arg.value( 'edit' )!
			return this.$.$giper_baza_glob.Pawn( new $giper_baza_link( ref_str ), $shm_hitalama_vk_list )
		}

		remove_list( ref: $giper_baza_link ) {
			this.$.$shm_hitalama_profile.current()?.Groups_lists()?.cut( ref )
		}
		
	}

}
